'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import { BoxInputField } from './BoxInputField';
import { BoxInputContainer, BoxInputWrapper, InputMessage } from './elements';
import { BoxInputState } from './types';
import { isReactDevelopment, useId } from '../../util';
export const BoxInput = ({
  id: incomingId,
  state,
  message,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  className,
  autoTab,
  values,
  mask,
  autoFocus,
  autoComplete,
  ...rest
}) => {
  const id = useId('box-input-field', incomingId);
  useEffect(() => {
    if (isReactDevelopment() && !ariaLabel && !ariaLabelledBy) {
      console.warn('Asurion UI BoxInput is missing `aria-label` or `aria-labelledby` prop.');
    }
  }, []);

  /* eslint-disable jsx-a11y/no-autofocus */
  return /*#__PURE__*/React.createElement(BoxInputContainer, null, /*#__PURE__*/React.createElement(BoxInputWrapper, {
    className: className,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": message && `${id}-message`,
    role: "group"
  }, values.map((value, i) => /*#__PURE__*/React.createElement(BoxInputField, _extends({}, rest, {
    key: i,
    id: `${id}-${i}`,
    index: i,
    mask: mask ?? false,
    state: state ?? BoxInputState.Default,
    autoFocus: autoFocus ?? false,
    autoTab: autoTab ?? true,
    autoComplete: autoComplete ?? 'one-time-code',
    values: values,
    value: value
  })))), message && /*#__PURE__*/React.createElement(InputMessage, {
    id: `${id}-message`,
    state: state
  }, message));
};